export default __webpack_public_path__ + "static/headerImage-cfdf837c539db53589ff1c3deb933012.png";